import { render, staticRenderFns } from "./SearchClientBig.vue?vue&type=template&id=d8d06ee6&scoped=true"
import script from "./SearchClientBig.vue?vue&type=script&lang=js"
export * from "./SearchClientBig.vue?vue&type=script&lang=js"
import style0 from "./SearchClientBig.vue?vue&type=style&index=0&id=d8d06ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d06ee6",
  null
  
)

export default component.exports